import { useInfiniteQuery } from '@tanstack/react-query';
import { api } from './client';
import type { AuditLog, ListEnvelope } from './types';

export interface AuditFilters {
  action?: string;
  entityType?: string;
  actorId?: string;
}

export function useAuditLogs(filters: AuditFilters) {
  return useInfiniteQuery({
    queryKey: ['audit-logs', filters],
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam, signal }) =>
      api<ListEnvelope<AuditLog>>('/audit-logs', {
        query: { ...filters, limit: 50, cursor: pageParam },
        signal,
      }),
    getNextPageParam: (last) => last.pagination.nextCursor ?? undefined,
  });
}
